<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-dialog persistent
                  v-model="$store.getters.bookVolumeModal"
                  max-width="500">

            <v-card>
                <v-card-title
                        class="headline primary white--text"
                        primary-title>
                    Τόμοι
                </v-card-title>

                <v-card-text class="mt-5">
                    <v-row>
                        <v-col cols="9">
                            <v-text-field
                                    dense
                                    label="Τόμος"
                                    outlined
                                    required
                                    v-model="volumeNumber"
                            ></v-text-field>
                        </v-col>
                        <v-col>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-on="on" fab color="primary" class="text--white" small ><v-icon>search</v-icon></v-btn>
                                </template>
                                <span>Τόμοι Βιβλίου</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-text-field
                                dense
                                label="Τίτλος Τόμου"
                                outlined
                                required
                                v-model="volumeTitle"
                        ></v-text-field>
                    </v-row>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            text
                            @click="closeModal">
                        Κλείσιμο
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>

    import {eventBus} from "../../main";

    export default {
        name: "BookVolume",
        data: () => ({
            volumeNumber: '',
            volumeTitle: '',
        }),
        props: {
            disableAllFields: Boolean,
        },

        methods: {

            closeModal() {
              this.$store.commit('setBookVolumeModal', false);
            },

        //   fill the field
            fillTheField(volumeNumber,volumeTitle) {
                this.volumeNumber = volumeNumber;
                this.volumeTitle = volumeTitle;
            }
        },

        created() {

            eventBus.$on('fillTheField', ((volumeNumber,volumeTitle) => {
                this.fillTheField(volumeNumber,volumeTitle);
            }));
        }
    }
</script>

<style scoped>

</style>